module.exports = __webpack_public_path__ + "static/media/icon_121_Netzwerke - Nachbarschaften_prev.2eb8841d.png";